import Vue from 'vue'
import popup from './tui-popup.vue'

const popupBox = Vue.extend(popup)

popup.install = function (data) {
    let instance = new popupBox({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
    })
}

export default popup